import { MathUtils } from 'three';
import { Vehicle } from 'core/models/vehicle';
import { Project } from 'core/models/project';
import { Environment } from 'core/models/environment';
import { RTCCommandAck, RTCTask } from 'core/models/rtc';
import { RTCResponseListener, VehicleRepository } from 'core/repositories/VehicleRepository';

export class RTCCommandManager {
    private pending = new Map<string, Map<string, (responses: RTCCommandAck) => void>>();

    private readonly listener: RTCResponseListener = (responses, transactionId) => {
        if (!transactionId) return;

        const waiting = this.pending.get(transactionId);
        if (!waiting) return;

        this.pending.delete(transactionId);

        responses.forEach(res => {
            const cb = waiting.get(res.uuid);
            if (cb) {
                cb(res);
            }
        });
    };

    constructor(
        public readonly repository: VehicleRepository,
        public readonly vehicleId: Vehicle.Id,
        public readonly projectId: Project.Id,
        public readonly environmentId: Environment.Id
    ) {
        this.repository.addRTCCommandResponseListener(this.vehicleId, this.projectId, this.listener);
    }

    dispose() {
        this.repository.removeRTCCommandResponseListener(this.vehicleId, this.projectId, this.listener);
    }

    async postRTCCommand(task: RTCTask, activated: boolean): Promise<boolean> {
        const tx = MathUtils.generateUUID();
        await this.repository.postRTCCommand(this.vehicleId, this.projectId, this.environmentId, task, activated, tx);

        const p = new Promise<RTCCommandAck>(resolve => {
            this.pending.set(tx, new Map([[tx, res => resolve(res)]]));
        });
        return p.then(res => res.success);
    }
}
